// extracted by mini-css-extract-plugin
export const logoStyles = "clientLogos-module--logoStyles--7rNiW";